import { useCallback, useState } from 'react';

export default function useDisclosure(initial = false) {
    const [isOpen, setIsOpen] = useState(Boolean(initial));

    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);
    const toggle = useCallback(() => setIsOpen((v) => !v), []);

    return { isOpen, open, close, toggle, setIsOpen };
}


